import { render } from "./ModelChipCell.vue?vue&type=template&id=66532e59&scoped=true"
import script from "./ModelChipCell.vue?vue&type=script&lang=js"
export * from "./ModelChipCell.vue?vue&type=script&lang=js"

import "./ModelChipCell.vue?vue&type=style&index=0&id=66532e59&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66532e59"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QBtn});
